import { SerializableObject } from '../../../legacy/objects/generic/serialization/serializable-object';

import { SessionUrlConstructor } from './session-url-constructor';
import { SessionURLSchema } from './session-url-schema';

export class SessionURL extends SerializableObject {
  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: SessionUrlConstructor) {
    super(parameters);
  }
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected baseUrl!: string;

  protected searchParams: Map<string, string> | undefined;

  /////////////////////////////////////////////////////////////////////////////
  // Get Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SessionURLSchema {
    return new SessionURLSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(SessionURL.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  protected static _deserialize(validationResult: import('joi').ValidationResult): SessionURL {
    return new SessionURL(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getBaseUrl() {
    return this.baseUrl;
  }

  public getSearchParams() {
    return this.searchParams;
  }

  public getPathname() {
    return new URL(this.baseUrl).pathname;
  }
}
